import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { useTypedSelector } from 'hooks';

import { AudienceWizardValues } from '../audienceBuilder/audienceAdapter';
import { saveAudience } from '../audienceBuilder/saveAudience';
import { RewardWizardValues } from '../rewardWizard/rewardAdapter';
import { saveReward } from '../rewardWizard/saveReward';
import { TransactionRuleValues } from '../ruleWizard/ruleAdapter';
import { saveRule } from '../ruleWizard/saveRule';
import { DEFAULT_TIMEZONE } from './configModel';
import { ConfigSubmit } from './configSubmission';

export interface IConfigStudioSaves {
  rule: ConfigSubmit<TransactionRuleValues>;
  reward: ConfigSubmit<RewardWizardValues>;
  audience: ConfigSubmit<AudienceWizardValues>;
}

/**
 * The module create APIs behind the rule, reward and audience flows. The answers the design draws
 * with no module key (`unsupported`) are not sent: they wait on the backend asks.
 */
const useConfigStudioSaves = (): IConfigStudioSaves => {
  const dispatch = useDispatch();
  const timezone = useTypedSelector(
    store => store.global?.tenantConfig?.localization?.timezone ?? DEFAULT_TIMEZONE
  );
  return useMemo(
    () => ({
      rule: ({ intent, values }) => saveRule(values, intent, timezone),
      reward: ({ intent, values }) => saveReward(dispatch, values.values, intent),
      audience: ({ values }) => saveAudience(values.values)
    }),
    [dispatch, timezone]
  );
};

export default useConfigStudioSaves;
